import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { LOGO_URL, COMPANY, SERVICE_CITIES } from "../lib/constants";

export default function Footer() {
  return (
    <footer className="grain-dark text-gray-300" data-testid="site-footer">
      <div className="ubm-container py-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={LOGO_URL} alt="UBM logo" className="h-12 w-12 object-contain" />
            <span className="font-display font-bold text-white text-lg">UBM</span>
          </div>
          <p className="text-sm leading-relaxed text-gray-400">
            United Building Maintenance and Residential Cleaning Services — reliable commercial and residential cleaning across {COMPANY.region}.
          </p>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/commercial" className="hover:text-primary transition-colors">Commercial Cleaning</Link></li>
            <li><Link to="/residential" className="hover:text-primary transition-colors">Residential Cleaning</Link></li>
            <li><Link to="/book" className="hover:text-primary transition-colors">Book a Cleaning</Link></li>
            <li><Link to="/employment" className="hover:text-primary transition-colors">Employment</Link></li>
            <li><Link to="/about" className="hover:text-primary transition-colors">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 text-primary" /><a href={COMPANY.phoneLink} className="hover:text-primary">{COMPANY.phoneDisplay}</a></li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 text-primary" /><a href={COMPANY.emailLink} className="hover:text-primary break-all">{COMPANY.email}</a></li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-primary" /><span>{COMPANY.region}</span></li>
            <li className="flex items-start gap-2"><Clock size={16} className="mt-0.5 text-primary" /><span>Mon–Fri 8–6, Sat 9–3</span></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Service Area</h4>
          <div className="flex flex-wrap gap-1.5">
            {SERVICE_CITIES.map((c) => (
              <span key={c} className="text-xs bg-charcoal-800 border border-charcoal-700 px-2 py-1 rounded">{c}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-charcoal-700">
        <div className="ubm-container py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <span>© {new Date().getFullYear()} United Building Maintenance and Residential Cleaning Services. All rights reserved.</span>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-primary">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-primary">Terms & Conditions</Link>
            <Link to="/admin/login" className="hover:text-primary">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
